import * as Action from "./action";

const defineInitialState = () => ({
  isAuthenticated: false,
  session: null,
  token: "",
  register: null,
});

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$saveSignup.ACTION:
      return {
        ...state,
        register: action?.register,
      };
    case Action.$signin.REQUEST:
      return {
        ...state,
        session: null,
        token: "",
      };
    case Action.$signin.SUCCESS:
      return {
        isAuthenticated: true,
        // session: { user: action.response.user },
        session: action.response.user,
        token: action.response.token,
        register: null,
      };
    case Action.$googleConnect.REQUEST:
      return {
        ...state,
        session: null,
        token: "",
      };
    case Action.$googleConnect.SUCCESS:
      return {
        isAuthenticated: true,
        session: action?.response?.user,
        token: action?.response?.token,
        register: null,
      };
    case Action.$verify.SUCCESS:
      return {
        isAuthenticated: true,
        token: action.response.token,
        session: action.response.user,
        register: null,
      };
    case Action.$fetchProfile.SUCCESS:
      return {
        ...state,
        // session: { user: action.response.user },
        session: action.response.user,
      };
    case Action.$logout.ACTION:
      return {
        isAuthenticated: false,
        session: null,
        token: "",
        register: null,
      };
    default:
      return state;
  }
}

export function persister({ isAuthenticated, session, token, register }) {
  return {
    isAuthenticated,
    session,
    token,
    register,
  };
}
